module.exports = __webpack_public_path__ + "static/media/PDF_102.cd34b32b.pdf";